import { IScreenShareData } from "common/records/ScreenShare";
import { ScreenShareKindValues, ScreenShareStatusValues } from "common/reducers/screenShare.reducer";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const SET_SCREEN_SHARE_STATUS = "@screenShares/SET_SCREEN_SHARE_STATUS";
export const SET_SCREEN_SHARE_KIND = "@screenShares/SET_SCREEN_SHARE_KIND";
export const SET_ACTIVE_SCREEN_SHARE_JOB = "@screenShares/SET_ACTIVE_SCREEN_SHARE_JOB";
export const FETCH_SCREEN_SHARE = "@screenShares/FETCH_SCREEN_SHARE";
export const RECEIVE_SCREEN_SHARE = "@screenShares/RECEIVE_SCREEN_SHARE";
export const RECEIVE_SCREEN_SHARE_TOKEN = "@screenShares/RECEIVE_SCREEN_SHARE_TOKEN";
export const SET_SCREEN_SHARE_LOADED = "@screenShares/SET_SCREEN_SHARE_LOADED";
export const RECEIVE_ROOM_STATUS = "@screenShares/RECEIVE_ROOM_STATUS";
export const SET_LANDING_LOADED = "@screenShares/SET_LANDING_LOADED";

export const ScreenShareActions = {
  setScreenShareStatus: (jobId: number, status: ScreenShareStatusValues) =>
    createAction(SET_SCREEN_SHARE_STATUS, { jobId: jobId, status: status }),
  setScreenShareKind: (jobId: number, kind: ScreenShareKindValues) =>
    createAction(SET_SCREEN_SHARE_KIND, { jobId: jobId, kind: kind }),
  setActiveScreenShareJob: (jobId: number) => createAction(SET_ACTIVE_SCREEN_SHARE_JOB, jobId),
  fetchScreenShare: (jobId: number, id: number) => createAction(FETCH_SCREEN_SHARE, { id: id, jobId: jobId }),
  setScreenShareLoaded: (jobId: number) => createAction(SET_SCREEN_SHARE_LOADED, { jobId }),
  receiveScreenShare: (jobId: number, screenShare: Partial<IScreenShareData>) =>
    createAction(RECEIVE_SCREEN_SHARE, { jobId: jobId, screenShare: screenShare }),
  receiveToken: (token: string) => createAction(RECEIVE_SCREEN_SHARE_TOKEN, token),
  receiveRoomStatus: (status: boolean) => createAction(RECEIVE_ROOM_STATUS, status),
  setLandingLoaded: (loaded: boolean) => createAction(SET_LANDING_LOADED, { loaded }),
};

export type ScreenShareActions = ActionsUnion<typeof ScreenShareActions>;
